import { render } from "./EditPago.vue?vue&type=template&id=22a857e0"
import script from "./EditPago.vue?vue&type=script&lang=js"
export * from "./EditPago.vue?vue&type=script&lang=js"

import "./EditPago.vue?vue&type=style&index=0&id=22a857e0&lang=css"
import "./EditPago.vue?vue&type=style&index=1&id=22a857e0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__